<div class="modal-header">
  <h5 class="modal-title">
    <ng-container *ngIf="!isEditing" i18n>Set Cost Formula </ng-container>
    <ng-container *ngIf="isEditing" i18n>Edit Cost Formula </ng-container>
    <small
      ><i
        matTooltip="Set an adjustment to the inquiry’s imported booking charges."
        i18n-matTooltip
        matTooltipPosition="above"
        matTooltipClass="text-center"
        class="fal info fa-question-circle"
      ></i
    ></small>
  </h5>
  <button (click)="onClose()" type="button" class="close">
    <span class="fas fa-times"></span>
  </button>
</div>
<div class="modal-body">
  <div class="box box-mt-has-pd clearfix">
    <form [formGroup]="form" class="row">
      <div class="col-12">
        <mat-form-field class="mat-block">
          <mat-select formControlName="base" placeholder="Start the adjustment formula with" i18n-placeholder>
            <mat-option value="total" i18n>Booking Total</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 checkbox-has-pd">
        <mat-button-toggle-group
          formControlName="cumulativeSubtraction"
          tooltip="This allows you to switch the behavior between cumulative subtraction and aggregate subtraction."
          container="body"
        >
          <mat-button-toggle [value]="false" i18n> Aggregate </mat-button-toggle>
          <mat-button-toggle [value]="true" i18n> Cumulative </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div
        formArrayName="formulas"
        *ngFor="let item of formulas.controls; let i = index; let last = last"
        class="col-12 edit-cost-operation-box"
      >
        <div [formGroupName]="i" class="row">
          <div class="col-3">
            <mat-form-field class="mat-block">
              <mat-label i18n> Name: </mat-label>
              <input type="text" formControlName="name" matInput />
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field class="mat-block">
              <mat-select formControlName="operation" placeholder="Operation" i18n-placeholder>
                <mat-option value="add" i18n>Add (+)</mat-option>
                <mat-option value="subtract" i18n>Subtract (-)</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field class="mat-block">
              <mat-label i18n> Amount ({{ operator(i) }}): </mat-label>
              <input type="text" formControlName="amount" matInput />
              <mat-error *ngIf="item.get('amount').hasError('min')" i18n> Minimum value is 0. </mat-error>
              <mat-error *ngIf="item.get('amount').hasError('max')" i18n> Maximum value is 100. </mat-error>
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field class="mat-block">
              <mat-select formControlName="type" placeholder="Type" i18n-placeholder>
                <mat-option value="percent" i18n>Percent</mat-option>
                <mat-option value="flat" i18n>Flat</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-12 btn-plus-circle">
            <button *ngIf="last" (click)="addFormula()" type="button" class="btn btn-success btn-circle text-uppercase">
              <span class="fas fa-plus"></span>
            </button>
            <button
              *ngIf="!last"
              (click)="removeFormula(i)"
              type="button"
              class="btn btn-danger btn-circle text-uppercase"
            >
              <span class="fas fa-minus"></span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button (click)="onClose()" type="button" [ngClass]="config.cancelBtnClass">
    <i class="fal fa-times"></i> <ng-container i18n>cancel</ng-container>
  </button>
  <button (click)="onClear()" type="button" [ngClass]="config.clearBtnClass">
    <i class="fal fa-backspace"></i> <ng-container i18n>clear</ng-container>
  </button>
  <button (click)="onSave(form)" type="button" [ngClass]="config.doneBtnClass">
    <i [ngClass]="config.doneBtnIconClass"></i> <ng-container i18n>done</ng-container>
  </button>
</div>
